var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.011,
    height: 25.545,
    viewBox: "0 0 20.011 25.545",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "xls-svgrepo-com",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14174",
    "data-name": "Trazado 14174",
    d: "M48.6,0H32.842V25.545H52.853V4.257Z",
    transform: "translate(-32.842)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_463",
    "data-name": "Grupo 463",
    transform: "translate(4.892 5.199)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1612",
    "data-name": "Rect\\xE1ngulo 1612",
    width: 10.101,
    height: 10.101,
    transform: "translate(0)",
    fill: "#007934"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1613",
    "data-name": "Rect\\xE1ngulo 1613",
    width: 8.349,
    height: 8.349,
    transform: "translate(0.876 0.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14175",
    "data-name": "Trazado 14175",
    d: "M164.617,137.423h-2.576l.761.95-.761.95h2.576l-.761-.95Z",
    transform: "translate(-156.047 -131.043)",
    fill: "#007934"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14176",
    "data-name": "Trazado 14176",
    d: "M118.394,97.886h-2.466l-.547.683-.547-.683h-2.466l1.779,2.222-1.779,2.222h6.025l-1.779-2.222Z",
    transform: "translate(-110.56 -94.837)",
    fill: "#007934"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14177",
    "data-name": "Trazado 14177",
    d: "M121.033,101.616h-.357l3.056,3.816h.357Z",
    transform: "translate(-118.167 -98.253)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14178",
    "data-name": "Trazado 14178",
    d: "M49.254,2.129H32.842V0H48.6Z",
    transform: "translate(-32.842)",
    fill: "#007934"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_464",
    "data-name": "Grupo 464",
    transform: "translate(4.624 18.974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14179",
    "data-name": "Trazado 14179",
    d: "M91.79,229.934H90.527l-.788-1.264-.78,1.264H87.723l1.341-2.068L87.8,225.892h1.211l.73,1.25.7-1.25h1.247l-1.28,2.06Z",
    transform: "translate(-87.723 -225.834)",
    fill: "#a4a9ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14180",
    "data-name": "Trazado 14180",
    d: "M141.38,229.934v-4.042h1.092v3.16h1.557v.882H141.38Z",
    transform: "translate(-136.859 -225.834)",
    fill: "#a4a9ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14181",
    "data-name": "Trazado 14181",
    d: "M181.1,228.076a1.192,1.192,0,0,1-.191.668,1.249,1.249,0,0,1-.55.453,2.04,2.04,0,0,1-.843.162,3.414,3.414,0,0,1-.677-.057,2.512,2.512,0,0,1-.57-.2v-.973a3.254,3.254,0,0,0,.65.25,2.421,2.421,0,0,0,.619.09.6.6,0,0,0,.357-.084.259.259,0,0,0,.113-.217.239.239,0,0,0-.046-.145.531.531,0,0,0-.147-.126q-.1-.064-.538-.26a2.577,2.577,0,0,1-.593-.348,1.07,1.07,0,0,1-.293-.387,1.285,1.285,0,0,1-.1-.517,1.036,1.036,0,0,1,.406-.871,1.792,1.792,0,0,1,1.117-.312,3.133,3.133,0,0,1,1.28.29l-.335.843a2.425,2.425,0,0,0-.979-.26.51.51,0,0,0-.31.075.226.226,0,0,0-.1.185.267.267,0,0,0,.123.213,4.686,4.686,0,0,0,.668.343,1.846,1.846,0,0,1,.726.5A1.1,1.1,0,0,1,181.1,228.076Z",
    transform: "translate(-170.637 -225.203)",
    fill: "#a4a9ad"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14182",
    "data-name": "Trazado 14182",
    d: "M219.821,4.257h4.257L219.821,0Z",
    transform: "translate(-204.067)",
    fill: "#d1d3d3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.3a202bf0e70af51291adb3bbd77d6aee.svg";
export { ForwardRef as ReactComponent };